
<div class="row justify-content-center  p-5" *ngIf="!loaded">
    <div class="spinner-border text-primary" role="status">
        <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
    </div>
</div>

<div class="row pt-3" *ngIf="loaded">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
       {{'pages.securitycase.secIncDesc' | translate}}
       <div class="mt-4">
           <button class="btn btn-primary" (click)="exportReport(content);" data-toggle="tooltip" data-placement="top" title="{{ 'pages.support.dashboard.downloadResDesc' | translate }}" *ngIf="!generateReportLoading">
                {{ 'pages.generic.generateReport' | translate }}
            </button>
            <button class="btn btn-primary" type="button" *ngIf="generateReportLoading">
                <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                {{ 'pages.generic.loading' | translate }}
            </button>
       </div>
       <ngb-alert
            *ngIf="reportGenerated === true"
            type="success"
            class="mt-4 mb-5">
            <p class="mb-0">
            <fa-icon [icon]="['fas', 'exclamation-circle']" size="md" data-placement="top" title="waiting icon" class="mr-3"></fa-icon>
            Report has been generated
            </p>
        </ngb-alert>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-center pt-2" *ngIf="loaded && errorMessage">

        <h4 style="color:red;">{{errorMessage}}</h4>

    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12" *ngIf="loaded && !errorMessage">

        <div class="row">
            <div class="col-12">
                <h2>{{'pages.securitycase.tpvfaDesc' | translate}}</h2>
            </div>
        </div>

        <highcharts-chart
            [Highcharts]="Highcharts"
            [options]="tpvfpDonutChartOptions"
            [(update)]="updateDonutFlag"
            [oneToOne]=true
            style="width: 100%; display: block;"
        ></highcharts-chart>

    </div>
</div>

<div class="row pt-3" *ngIf="loaded && !errorMessage">
    <div class="col-12">

        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : page === 'tp' }" (click)="page = 'tp'">True Positives</a>
            </li> 
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : page === 'fp' }" (click)="page = 'fp'">False Positives</a>
            </li>
        </ul>
            
    </div>
</div>

<div class="row pt-3" *ngIf="loaded && !errorMessage">
    <div class="col-1"></div>
    <div class="col-10">
        
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : subpage === 'analytics' }" (click)="subpage = 'analytics'">{{'pages.securitycase.analytics' | translate}}</a>
            </li> 
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{ 'active' : subpage === 'data' }" (click)="subpage = 'data'; dataTabClicked()">Data</a>
            </li>
        </ul>
            
    </div>
    <div class="col-1"></div>
</div>


<div class="row pt-4" *ngIf="loaded && page === 'tp' && subpage === 'analytics' && !errorMessage">
    <div class="col-1"></div>
    <div class="col-10">
    
        <div class="row">
            <div class="col-xl-11 col-lg-11 col-md-11 col-sm-12 col-12 text-left justify-content-left">

                <highcharts-chart
                    [Highcharts]="Highcharts"
                    [options]="catColumnChartOptions"
                    [(update)]="updateFlag"
                    [oneToOne]=true
                    style="width: 100%; height: 500px; display: block;" 
                ></highcharts-chart>

            </div>
            <div class="col-xl-1 col-lg-1 col-md-1 col-sm-12 col-12 text-center">
                <ng-template #actor>{{'pages.securitycase.threatActorDesc' | translate}}</ng-template>
                <ng-template #killchain>{{'pages.securitycase.threatKillchainDesc' | translate}} </ng-template>
                <ng-template #action>{{'pages.securitycase.threatActionDesc' | translate}} </ng-template>
                <ng-template #asset>Threat Asset </ng-template>
                <ng-template #attributes>{{'pages.securitycase.threatAttributesDesc' | translate}}</ng-template>

                <button class="btn" [ngbTooltip]="actor" (click)="updateGraph('actor')"><fa-icon [icon]="['fas', 'user']" size="2x"></fa-icon></button>
                <button class="btn" [ngbTooltip]="killchain" (click)="updateGraph('killchain')"><fa-icon [icon]="['fas', 'bullseye']" size="2x"></fa-icon></button>
                <button class="btn" [ngbTooltip]="action" (click)="updateGraph('action')"><fa-icon [icon]="['fas', 'check-square']" size="2x"></fa-icon></button>
                <button class="btn" [ngbTooltip]="asset" (click)="updateGraph('u_asset')"><fa-icon [icon]="['far', 'check-square']" size="2x"></fa-icon></button>
                <button class="btn" [ngbTooltip]="attributes" (click)="updateGraph('attributes')"><fa-icon [icon]="['fas', 'list']" size="2x"></fa-icon></button>

            </div>
        </div>

    </div>
</div>

<div class="row pt-5" *ngIf="loaded && !errorMessage">
    <div class="col-1"></div>
    <div class="col-10">
    
        <div class="row">
            <div class="col-12 text-center">
                <h2>Monthly breakdown</h2>
                <button class="btn" (click)="changeMonth('back')"><fa-icon [icon]="['fas', 'caret-square-left']" size="2x"></fa-icon></button> <span style="font-size: 1.5rem;">{{currentMonth}}</span><button class="btn" (click)="changeMonth('fwd')"><fa-icon [icon]="['fas', 'caret-square-right']" size="2x"></fa-icon></button>
            </div>
        </div>

    </div>
</div>

<div class="row pt-3" *ngIf="loaded && page === 'tp' && subpage === 'analytics' && !errorMessage">
    <div class="col-1"></div>
    <div class="col-10">

        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12  p-0">

                <div class="row pt-5">
                    <div class="col-12 text-center">
                        <h3>{{'pages.securitycase.threatActorDesc' | translate}} 
                            <app-help message="{{'pages.securitycase.threatActorDescD' | translate}}"></app-help>
                        </h3>
                    </div>
                </div>
                <div class="row p-0">
                    <div class="col-12 text-center p-0">

                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="actorDonutChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>
            
                    </div>
                </div>

            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 p-0 text-center">

                <div class="row pt-5">
                    <div class="col-12 text-center">
                        <h3>{{'pages.securitycase.threatKillchainDesc' | translate}}
                            <app-help message="{{'pages.securitycase.threatKillchainDescD' | translate}}"></app-help>
                        </h3>
                        <div class="btn-group" role="group" aria-label="Toggle view">
                            <ng-template #ringView> Show Ring format </ng-template>
                            <ng-template #barView> Show Bar Format </ng-template>
                            
                            <button class="btn btn-icon" [ngbTooltip]="barView" (click)="killchainView = 'bar'" [ngClass]="{'active':killchainView == 'bar' }"><fa-icon [icon]="['fas', 'chart-bar']" size="2x" class="text-center" [fixedWidth]="true"></fa-icon></button>
                            <button class="btn btn-icon" [ngbTooltip]="ringView" (click)="killchainView = 'ring'" [ngClass]="{'active':killchainView == 'ring' }"><fa-icon [icon]="['fas', 'chart-pie']" size="2x" class="text-center" [fixedWidth]="true"></fa-icon></button>
                    
                        </div>
                    </div>
                </div>
                <div class="row p-0" *ngIf="killchainView == 'bar'">
                    <div class="col-12 text-center p-0">

                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="killchainColumnChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>

                    </div>
                </div>
                <div class="row p-0" *ngIf="killchainView == 'ring'">
                    <div class="col-12 text-center p-0">

                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="killchainDonutChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>

                    </div>
                </div>
                
            </div>
        </div>

        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 ">

                <div class="row pt-5">
                    <div class="col-12 text-center">
                        <h3>{{'pages.securitycase.threatActionDesc' | translate}} 
                            <app-help message="{{'pages.securitycase.threatActionDescD' | translate}}"></app-help>
                        </h3>
                        <div class="btn-group" role="group" aria-label="Toggle view">
                            <ng-template #ringView> Show Ring format </ng-template>
                            <ng-template #barView> Show Bar Format </ng-template>

                            <button class="btn btn-icon" [ngbTooltip]="ringView" (click)="actionView = 'ring'" [ngClass]="{'active':actionView == 'ring' }"><fa-icon [icon]="['fas', 'chart-pie']" size="2x" class="text-center" [fixedWidth]="true"></fa-icon></button> 
                            <button class="btn btn-icon" [ngbTooltip]="barView" (click)="actionView = 'bar'" [ngClass]="{'active':actionView == 'bar' }"><fa-icon [icon]="['fas', 'chart-bar']" size="2x" class="text-center" [fixedWidth]="true"></fa-icon></button>
                    
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="actionView == 'ring'">
                    <div class="col-12 text-center p-0">
            
                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="actionDonutChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>
            
                    </div>
                </div>
                <div class="row" *ngIf="actionView == 'bar'">
                    <div class="col-12 text-center p-0">
            
                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="actionBarChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>
            
                    </div>
                </div>
            
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 ">

                <div class="row pt-5">
                    <div class="col-12 text-center">
                        <h3>{{'pages.securitycase.threatAssetsDesc' | translate}} 
                            <app-help message="{{'pages.securitycase.threatAssetsDescD' | translate}}"></app-help>
                        </h3>
                        <div class="btn-group" role="group" aria-label="Toggle view">
                            <ng-template #ringView> Show Ring format </ng-template>
                            <ng-template #barView> Show Bar Format </ng-template>
                            
                            <button class="btn btn-icon" [ngbTooltip]="barView" (click)="assetView = 'bar'" [ngClass]="{'active':assetView == 'bar' }"><fa-icon [icon]="['fas', 'chart-bar']" size="2x" class="text-center" [fixedWidth]="true"></fa-icon></button>
                            <button class="btn btn-icon" [ngbTooltip]="ringView" (click)="assetView = 'ring'" [ngClass]="{'active':assetView == 'ring' }"><fa-icon [icon]="['fas', 'chart-pie']" size="2x" class="text-center" [fixedWidth]="true"></fa-icon></button> 

                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="assetView == 'ring'">
                    <div class="col-12 text-center p-0">

                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="assetDonutChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>

                    </div>
                </div>
                <div class="row" *ngIf="assetView == 'bar'">
                    <div class="col-12 text-center p-0">

                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="assetBarChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>

                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 ">

                <div class="row pt-5">
                    <div class="col-12 text-center">
                        <h3>{{'pages.securitycase.threatAttributesDesc' | translate}}
                            <app-help message="{{'pages.securitycase.threatAttributesDescD' | translate}}"></app-help>
                        </h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center p-0">

                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="attributesChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>

                    </div>
                </div>

            </div>
           
        </div>

    </div>
</div>




<div class="row pt-3" *ngIf="loaded && page === 'fp' && subpage === 'analytics' && !errorMessage">
    <div class="col-1"></div>
    <div class="col-10">

        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12  p-0">

                <div class="row pt-5">
                    <div class="col-12 text-center">
                        <h3>{{'pages.securitycase.whatDesc' | translate}}
                            <app-help message="{{'pages.securitycase.whatDescD' | translate}}"></app-help>
                        </h3>
                    </div>
                </div>
                <div class="row p-0">
                    <div class="col-12 text-center p-0">

                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="whatDonutChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>
            
                    </div>
                </div>

            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 p-0 text-center">

                <div class="row pt-5">
                    <div class="col-12 text-center">
                        <h3>{{'pages.securitycase.whoDesc' | translate}}
                            <app-help message="{{'pages.securitycase.whoDescD' | translate}}"></app-help>
                        </h3>
                    </div>
                </div>
                <div class="row p-0">
                    <div class="col-12 text-center p-0">

                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="whoDonutChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>

                    </div>
                </div>
                
            </div>
        </div>

        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 ">

                <div class="row pt-5">
                    <div class="col-12 text-center">
                        <h3>{{'pages.securitycase.whyDesc' | translate}}
                            <app-help message="{{'pages.securitycase.whyDescD' | translate}}"></app-help>
                        </h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center p-0">
            
                        <highcharts-chart
                            [Highcharts]="Highcharts"
                            [options]="whyDonutChartOptions"
                            [(update)]="updateDonutFlag"
                            [oneToOne]=true
                            style="width: 100%; display: block;"
                        ></highcharts-chart>
            
                    </div>
                </div>
            
            </div>
        </div>

    </div>
</div>




<div class="row pt-3" *ngIf="loaded && page === 'tp' && subpage === 'data' && !errorMessage">
    <div class="col-1"></div>
    <div class="col-10">

        <div class="row">
            <div class="col-12">

                <div class="row faketableheaderrow">
                    <div class="col-xl-1 col-lg-1 col-md-2 col-sm-4 col-4 faketableheader" (click)="sortAssets('saseNumber');">
                        Case number <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-1 col-lg-1 col-md-2 d-none d-md-block faketableheader" (click)="sortAssets('status');">
                        Status <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-8 col-sm-8 col-8 faketableheader" (click)="sortAssets('Ssubject');">
                        Subject <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketableheader" (click)="sortAssets('action');">
                        Action/Sub Action <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketableheader" (click)="sortAssets('actor');">
                        Actor <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketableheader" (click)="sortAssets('killchain');">
                        Killchain <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                </div>

                <div class="row faketablerow" *ngFor="let case of currentMonthDataTP" [routerLink]="['/support/view/' + case.id]" routerLinkActive="activeLink">
                    <div class="col-xl-1 col-lg-1 col-md-2 col-sm-4 col-4 faketablecell">
                        {{case.caseNumber}}
                    </div>
                    <div class="col-xl-1 col-lg-1 col-md-2 d-none d-md-block faketablecell">
                        {{case.status}}
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-8 col-sm-8 col-8  faketablecell">
                        {{case.subject}}
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketablecell">
                        {{case.action}} / {{case.subAction}}
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketablecell">
                        {{case.actor}}
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketablecell">
                        {{case.killchain | replace : ';' : ','}}
                    </div>
                </div>

            </div>
        </div>
    
    </div>
</div>



<div class="row pt-3" *ngIf="loaded && page === 'fp' && subpage === 'data' && !errorMessage">
    <div class="col-1"></div>
    <div class="col-10">

        <div class="row">
            <div class="col-12">

                <div class="row faketableheaderrow">
                    <div class="col-xl-1 col-lg-1 col-md-2 col-sm-4 col-4 faketableheader" (click)="sortAssets('caseNumber');">
                        {{'pages.securitycase.caseNumber' | translate}} <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-2 col-lg-2 col-md-2 d-none d-md-block faketableheader" (click)="sortAssets('status');">
                        {{'pages.securitycase.status' | translate}} <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-8 col-sm-8 col-8 faketableheader" (click)="sortAssets('subject');">
                        {{'pages.securitycase.subject' | translate}} <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketableheader" (click)="sortAssets('whatFalsePositive');">
                        {{'pages.securitycase.what' | translate}} <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketableheader" (click)="sortAssets('whyFalsePositive');">
                        {{'pages.securitycase.why' | translate}} <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                    <div class="col-xl-1 col-lg-1 d-none d-lg-block faketableheader" (click)="sortAssets('whoFalsePositive');">
                        {{'pages.securitycase.who' | translate}} <fa-icon [icon]="['fas', 'sort']" class="p-1"></fa-icon>
                    </div>
                </div>

                <div class="row faketablerow" *ngFor="let case of currentMonthDataFP" [routerLink]="['/support/view/' + case.id]" routerLinkActive="activeLink">
                    <div class="col-xl-1 col-lg-1 col-md-2 col-sm-4 col-4 faketablecell">
                        {{case.caseNumber}}
                    </div>
                    <div class="col-xl-2 col-lg-2 col-md-2 d-none d-md-block faketablecell">
                        {{case.status}}
                    </div> 
                    <div class="col-xl-4 col-lg-4 col-md-8 col-sm-8 col-8 faketablecell">
                        {{case.subject}}
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketablecell">
                        {{case.whatFalsePositive}}
                    </div>
                    <div class="col-xl-2 col-lg-2 d-none d-lg-block faketablecell">
                        {{case.whyFalsePositive}}
                    </div>
                    <div class="col-xl-1 col-lg-1 d-none d-lg-block faketablecell">
                        {{case.whoFalsePositive}}
                    </div>
                </div>

            </div>
        </div>
    
    </div>
</div>

<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{ 'pages.generic.generateReport' | translate }}</h5>
    </div>
    <div class="modal-body">
        <div class="form-group col-12 pt-2">
            <label for="contact">{{ 'pages.generic.reportName' | translate }}</label>
            <input type="text" class="form-control" name="PDFName" aria-describedby="PDFName" [(ngModel)]="PDFName">
        </div>
        <div class="row">
            <div class="col-6">
                <select class="form-control" name="reportOpt" aria-describedby="reportOpt" [(ngModel)]="reportOption">
<!--                     <option value="pdf">PDF</option> -->
                    <option value="csv">CSV</option>
                </select>
            </div>
            <div class="col-6">
                <select class="form-control" name="reportLevel" aria-describedby="reportLevel" [(ngModel)]="pdfAccessLevel">
                    <option title="{{ 'pages.generic.ACCESS_INTERNAL_REPORTS' | translate }}" value="0">{{ 'pages.generic.internal' | translate }}</option>
                    <option title="{{ 'pages.generic.ACCESS_CONFIDENTIAL_REPORTS' | translate }}" value="1">{{ 'pages.generic.confidential' | translate }}</option>
                    <option title="{{ 'pages.generic.ACCESS_RESTRICTED_REPORTS' | translate }}" value="2">{{ 'pages.generic.restricted' | translate }}</option>
            </select>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')">{{ 'pages.generic.close' | translate }}</button>
        <button type="button" class="btn btn-primary" (click)="modal.close('save')">{{ 'pages.generic.save' | translate }}</button>
    </div>
</ng-template>

